import { CURRENCY } from "constant/constants";
import { formatNumber } from "helper/HelperFunction";
import { BsDot } from "react-icons/bs";
import { Button } from "../Core/Button";
import classes from "./SubscriptionCard.module.css";
import { GiDiamonds } from "react-icons/gi";

const SubscriptionCard = ({ data, editClick }) => {
  return (
    <>
      <div className={classes.container}>
        <div className={classes.header}>
          <p className={classes.packageTitle}>{data?.name}</p>
          <div className={classes.packagePrice}>
            <p>{formatNumber(data?.price)}</p>
            <span className={classes.priceMonth}>/month</span>
          </div>
          <p className={classes.packageDescription}>{data.description}</p>
        </div>
        <div className={classes.packageBox}>
          <p className={classes.packageHeading}>What’s included:</p>
          <div className={classes.packageDetailsBox}>
            {getPackageIncludesText(data, "highlight")?.map((el, index) => (
              <div className={classes.packageBoxContent} key={index}>
                <p className={classes.packageDetails}>
                  <GiDiamonds size={16} /> 
                  <span>{el}</span>
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.packageBtn}>
          <Button label={"Edit Plan"} onClick={editClick} />
        </div>
      </div>
    </>
  );
};

export default SubscriptionCard;

const getPackageIncludesText = (data, type) => {
  let array = [];
  if (type === "package") {
    if (data?.unlimitedServices && data?.unlimitedAds) {
      array.push(
        "Includes unlimited adds for unlimited amount of included services"
      );
    }
    if (!data?.unlimitedServices && data?.unlimitedAds) {
      array.push(
        `Includes unlimited adds for max ${data?.totalServices} services`
      );
    }
    if (data?.unlimitedServices && !data?.unlimitedAds) {
      array.push(`${data?.totalAds} Adds per month`);
    }
  } else if (type === "options") {
    if (data?.extraAd > 0) {
      array.push(`Additional Add ${data?.extraAd} ${CURRENCY}/each`);
    }
    if (data?.extraAd <= 0) {
      array.push(`Automatic highlight for each add`);
    }
    if (data?.highlightPerAd > 0) {
      array.push(`Highlight ${data?.highlightPerAd} adds per day`);
    }
  } else {
    array.push(`Special Offer ${formatNumber(data?.specialOffer)}`);
    array.push(`Middle  Add ${formatNumber(data?.middleAd)}`);
    array.push(`Large  Add ${formatNumber(data?.largeAd)}`);
  }
  return array;
};
